import { createContext, useContext } from "react";
import useDiscoveryRespondingAnswer from "../hooks/useDiscoveryRespondingAnswer";

const DiscoveryRespondingAnswerContext = createContext(null);

export const DiscoveryRespondingAnswerProvider = ({ children }) => {
    const respondingAnswer = useDiscoveryRespondingAnswer();

    return (
        <DiscoveryRespondingAnswerContext.Provider value={respondingAnswer}>
            {children}
        </DiscoveryRespondingAnswerContext.Provider>
    );
};

export const useDiscoveryRespondingAnswerContext = () => {
    const context = useContext(DiscoveryRespondingAnswerContext);
    if (!context) {
        throw new Error("useDiscoveryRespondingAnswerContext must be used within DiscoveryRespondingAnswerProvider");
    }
    return context;
};
